module.exports = __webpack_public_path__ + "media/images/icon_check2-07bef31a81763a4d93d1a1f45e584e36.svg";